module.exports = __webpack_public_path__ + "media/assets/kyronicon-small-8c83a33fa90b78d0a113ff2da3e94563.svg";